import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import React__default from 'react';
import classNames from 'classnames';
import styles from './48404219cb10939c86e5daacfa7d535fffaba81d8e00b9fd9aab9f417871c5f2.cfe-internal.js';
import { useToolbarContext } from './a160cf879b7cab120bf814e64f156f70cee237e5ec6d1ada4eef9b879e36d9b6.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import getSubDataTestId from '../../utils/getSubDataTestId/d234b5cba8708c34be51c9bf4976cdee0c55fe33ce1598dbff38a5cf644e53a8.cfe-internal.js';

var _excluded = ["isContainerInTabOrder", "children", "className", "aria-labelledby", "id", "data-testid"];
var ToolbarPanel = function ToolbarPanel(_ref) {
  var _context, _context2;
  var _ref$isContainerInTab = _ref.isContainerInTabOrder,
    isContainerInTabOrder = _ref$isContainerInTab === void 0 ? false : _ref$isContainerInTab,
    children = _ref.children,
    className = _ref.className,
    ariaLabelledby = _ref['aria-labelledby'],
    id = _ref.id,
    dataTestid = _ref['data-testid'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useToolbarContext = useToolbarContext(),
    selectedIndex = _useToolbarContext.selectedIndex,
    index = _useToolbarContext.index,
    toolbarId = _useToolbarContext.toolbarId,
    isCollapsed = _useToolbarContext.isCollapsed,
    rootDataTestId = _useToolbarContext.rootDataTestId;
  var isSelected = selectedIndex === index;
  var isFocusable = isSelected && !isCollapsed;
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    role: "tabpanel",
    className: classNames(className, styles.toolbarPanel, _defineProperty({}, styles.notSelected, !isSelected)),
    tabIndex: isFocusable && isContainerInTabOrder ? 0 : -1,
    "aria-labelledby": ariaLabelledby || _concatInstanceProperty(_context = "toolbar-".concat(toolbarId, "-tab-")).call(_context, index),
    id: id || _concatInstanceProperty(_context2 = "toolbar-".concat(toolbarId, "-panel-")).call(_context2, index),
    "data-testid": dataTestid || getSubDataTestId(rootDataTestId, "panel-".concat(index))
  }), isFocusable ? children : null);
};

export { ToolbarPanel as default };
